import React from "react";
import {
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Box,
  FormControl,
} from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { styled } from "@mui/material/styles";

const StyledFormControl = styled(FormControl)({
  display: "block",
  marginBottom: "16px",
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: "8px",
  borderRadius: "4px",
  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",

  "&:hover": {
    backgroundColor: "rgba(99, 91, 255, 0.08)",
  },

  "&.Mui-disabled": {
    opacity: 0.6,
  },
}));

const CustomCheckboxWidget: React.FC<WidgetProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  disabled,
  readonly,
  required,
  help,
  schema,
  uiSchema,
  formContext,
  registry,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <StyledFormControl fullWidth>
      <FormControlLabel
        control={
          <StyledCheckbox
            id={id}
            checked={Boolean(value)}
            onChange={handleChange}
            onBlur={() => onBlur?.(id, value)}
            onFocus={() => onFocus?.(id, value)}
            disabled={disabled || readonly}
            required={required}
            color="primary"
          />
        }
        label={label}
        sx={{
          alignItems: "center",
          marginLeft: 0,
          marginRight: 0,

          "& .MuiFormControlLabel-label": {
            marginLeft: "8px",
            fontSize: "0.95rem",
            userSelect: "none",
            cursor: disabled || readonly ? "not-allowed" : "pointer",
            opacity: disabled || readonly ? 0.6 : 1,
          },
        }}
      />
      {help && <FormHelperText sx={{ ml: 4, mt: 0.5 }}>{help}</FormHelperText>}
    </StyledFormControl>
  );
};

export default CustomCheckboxWidget;
